export default "__VITE_ASSET__80fa6071__"